import React, {Component} from 'react';
import ReactTable from 'react-table';
import { UncontrolledTooltip } from 'reactstrap';

import TagStore from "../../../stores/TagStore";
import AddTag from "../AddTag";
import UpdateTag from "../UpdateTag";
import swal from 'sweetalert';
import '../../../scss/App.scss';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import TagActions from "../../../actions/TagActions";
import LoginStore from "../../../stores/LoginStore";
import AppUtils, { gridStringFilter } from "../../../utils/AppUtils";
import AddStateTag from './AddStateTag';
import UpdateStateTag from './UpdateStateTag';


class StateTag extends Component {

  constructor(props) {
    super(props);
    this.state = {
      id: "",
      tags: [],
      isInsertForm: false,
      isEditingForm: false,
      showTagKey: true,
      showTagName: true,
      showTagDesc: true,
      showTagStates:true,
      showOptions: false,
      dataLoading: false,
      filterable:true,
      selectedTag:{}
    };
    this._onChange = this._onChange.bind(this);
    this.createNotification = this.createNotification.bind(this);
    this.showColumn = this.showColumn.bind(this);
    this.showColumnDetails = this.showColumnDetails.bind(this);
    this.deleteTag = this.deleteTag.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.hideModalClose = this.hideModalClose.bind(this);
    this.addNewTagModal = this.addNewTagModal.bind(this);
    this.filter = this.filter.bind(this);
  }


  createNotification(type) {
    try{
      switch (type) {
        case 'success':
          return NotificationManager.success('Tag added successfully', 'TAG ADDED', 2000);
        case 'NameExist':
          return NotificationManager.error('Unable to Add, Tag Name Already Exist', 'ERROR MESSAGE', 3000);
        case 'updated':
          return NotificationManager.success('Tag updated successfully', 'TAG UPDATED', 3000);
        case 'unableDelete':
          return NotificationManager.error('Unable to delete this tag', 'ERROR MESSAGE', 3000);
        case 'deleted':
          return NotificationManager.success('Tag has been deleted successfully', 'TAG DELETED', 3000);
        case 'sessionExpired':
          return NotificationManager.error('Session has been expired. Please login', 'SESSION EXPIRED', 2500);
        case 'fieldToFetch':
          return NotificationManager.error('Server has stopped please try later', 'ERROR MESSAGE', 2500);
        case 'error':
          return NotificationManager.error('Could not delete this Tag', 'ERROR MESSAGE', 3000);
        default:
          return '';
      }
    }catch(e){
      console.log('createNotification function in Tag ',e)
    }
  };

  componentDidMount() {
    TagStore.addChangeListener(this._onChange);
    TagActions.loadAllStateTagsRequest();
  }

  componentWillUnmount() {
    TagStore.removeChangeListener(this._onChange);
  }

  showColumn(column) {
    try{
      this.setState({[column]: !this.state[column]}, () => {
        return this.state[column];
      });
    }catch(e){
      console.log('showColumn function in Tag ',e)
    }
  }

  showColumnDetails() {
    return (
            <div className="w3-container form-inline modem-details">
              <div className="col-md-12 form-control form-inline">
                <div className="form-inline">
                  <input type="checkBox" onChange={() => {
                    this.showColumn("showTagKey")
                  }} checked={this.state.showTagKey ? 'checked' : ''} className="form-control-label"/>Key
                </div>
                <div className="form-inline">
                  <input type="checkBox" onChange={() => {
                    this.showColumn("showTagDesc")
                  }} checked={this.state.showTagDesc ? 'checked' : ''} className="form-control-label"/>Description
                </div>
                <div className="form-inline">
                  <input type="checkBox" onChange={() => {
                    this.showColumn("showTagStates")
                  }} checked={this.state.showTagStates ? 'checked' : ''} className="form-control-label"/>States
                </div>
              </div>
            </div>
    )
  }

  deleteTag(tag) {
    swal({
      title: "Are you sure you want to delete " + tag.TagName + " ?",
      text: "Once deleted, you will not be able to recover this Tag!",
      icon: "error",
      buttons: true,
      dangerMode: true
    }).then((willDelete) => {
      if (willDelete) {
        TagActions.deleteStates(tag.TagKey);
      }
    }).catch(e=>{console.log('deleteTag function in Tag ',e)});
  }

  hideModal() {
    document.getElementById('addTag').style.display = 'none';
    this.setState({isEditingForm: false, showOptions: false, isInsertForm: false});
  }

  hideModalClose() {
    document.getElementById('addTag').style.display = 'none';
    this.setState({isEditingForm: false, showOptions: false, isInsertForm: false});
  }

  addNewTagModal() {
    try{
      let DisplayHeaderModal = "";
      let tagAction = "";
      let width = "50%";
      if (this.state.isInsertForm) {
        DisplayHeaderModal = "New Tag";
        tagAction = <AddStateTag hideModal={this.hideModal.bind(this)}/>;
      }
      if (this.state.isEditingForm) {
        DisplayHeaderModal = "Edit Tag";
        tagAction = <UpdateStateTag id={this.state.id} hideModal={this.hideModal.bind(this)} tag={this.state.selectedTag}/>;
      }
      if (this.state.showOptions) {
        DisplayHeaderModal = "Columns Selector";
        width = "20%";
        tagAction = this.showColumnDetails();
      }
      return (
              <div className="w3-container">
                <div id="addTag" className="w3-modal">
                  <div className="w3-modal-content w3-card-4 w3-animate-zoom" style={{maxWidth: width}}>
                    <header className="w3-container header-modal">
                                  <span onClick={this.hideModalClose}
                                        className="w3-button close-btn w3-display-topright">&times;</span>
                      <h6>{DisplayHeaderModal}</h6>
                    </header>
                    <div className="w3-container" style={{paddingBottom: '10px'}}>
                      {tagAction}
                    </div>
                  </div>
                </div>
              </div>
      )
    }catch(e){
      console.log('addNewTagModal function in Tag ',e)
    }
  }

  settings() {
    return (
            <div className="">
              <span style={{paddingRight: "3px"}}>Actions</span>
              <div className="float-right mr-5" style={{cursor: 'pointer', zIndex: '999'}}
                   onClick={() => {
                     this.setState({showOptions: true});
                     document.getElementById('addTag').style.display = 'block';
                   }}><i title={"columns selector"} className="fa fa-gear"/>
              </div>
              <div className="float-right mr-5" style={{cursor: 'pointer', zIndex: '999'}}
                   onClick={this.filter}>
                <i title={"filter"} className="fa fa-search"/>
              </div>
            </div>
    )
  }

  filter() {
    this.setState({filterable: !this.state.filterable});
  }

  getColumns() {
    try{
      return [
        {
          Header: 'Key',
          id: 'TagKey',
          accessor: d => Number(d.TagKey),
          show: this.state.showTagKey,
          style: {
            textAlign: "center"
          },
          width: 100,
          maxWidth: 100,
          minWidth: 100,
        },
        {
          Header: 'Name',
          accessor: 'TagName',
          id: 'TagName',
          filterMethod: (filter, row) => {
            return gridStringFilter(filter, row);
          },
          show: this.state.showTagName
        },
        {
          Header: 'Description',
          accessor: 'TagDispName',
          id: 'TagDispName',
          filterMethod: (filter, row) => {
            return gridStringFilter(filter, row);
          },
          show: this.state.showTagDesc
        },
        {
            Header: 'States',
            accessor: 'states',
            id: 'states',
            show: this.state.showTagStates,
            width:100,
            filterable:false,
            style:{
                textAlign:'center',
            },
            Cell: props => {
                return <div>
                    <span className='fa fa-info-circle' style={{cursor:'pointer'}} id={`states_${props.row._original.TagKey}`}></span>
                    <UncontrolledTooltip placement="left" target={`states_${props.row._original.TagKey}`}>
                      <div className={'p-0 m-0'} style={{textAlign: "left"}}>
                        {
                          props.row._original?.TagStates?.map((st,index) => {
                            return <li key={`STATE_${index}`}>{st.StateDispName}</li>
                          })
                        }
                      </div>
                    </UncontrolledTooltip>
                </div>
            }
        },
        {
          Header: this.settings(),
          filterable: false,
          sortable: false,
          resizable: false,
          style: {
            textAlign: "center"
          },
          width: 100,
          maxWidth: 100,
          minWidth: 100,
          Cell: props => {
            return (
  
                    <div>
                      <button className="btn btn-xs btn-success action-btn" title="Edit Tag"
                              onClick={() => {
                                this.setState({isEditingForm: true});
                                this.setState({id: props.row._original.TagKey,selectedTag:props.row._original});
                                document.getElementById('addTag').style.display = 'block';
                              }}
                      >
                        <i className="fa fa-pencil-square-o"/>
                      </button>
                      <button className="btn btn-xs btn-danger action-btn" title="Delete Tag"
                              onClick={() => {
                                this.deleteTag(props.row._original)
                              }}
                      >
                        <i className="fa fa-trash-o"/>
                      </button>
                    </div>
            )
          }
        }
      ];
    }catch(e){
      console.log('getColumns function in Tag ',e)
    }
  }

  render() {

    return (
            <div className="row">
              <div className="col">
                <section className="content">
                  <div className="box">
                    <div className="box-header with-border box-header-title">
                      <div className="row mb-3">
                        <h3 className="col-xs-2 col-sm-2 col-md-2 col-lg-2 box-title">State Tags</h3>
                        <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                          <div className="btn-group btn-group-sm float-right" role="group">
                            <button
                                    onClick={() => {
                                      this.setState({isInsertForm: true});
                                      document.getElementById('addTag').style.display = 'block';
                                    }}
                                    title={"New Tag"}
                                    type="button" className="btn btn-primary react-bs-table-add-btn ">
                                                <span>
                                                    <i className="fa glyphicon glyphicon-plus fa-plus"/>
                                                </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="box-body">
                      {this.addNewTagModal()}
                      <ReactTable className="-striped -highlight" noDataText={"no data found"}
                                  data={this.state.tags} columns={this.getColumns()}
                                  loading={this.state.dataLoading}
                                  defaultFilterMethod={(filter, row) => AppUtils.filterCaseInsensitive(filter, row)}
                                  filterable={this.state.filterable}
                                  previousText={"<"}
                                  nextText={">"}
                                  defaultPageSize={25}
                                  getTdProps={() => {
                                    return {
                                      style: {
                                        fontSize: '14px',
                                        height: '33px',
                                        paddingLeft: '5px',
                                        paddingRight: '5px'
                                      }
                                    }
                                  }}
                      >
                      </ReactTable>

                    </div>
                  </div>
                </section>
              </div>
              <NotificationContainer/>
            </div>
    );
  }

  _onChange() {
    this.setState({
      tags: TagStore.getAllStateTags(),
      dataLoading: TagStore.getIsLoading(),
      serverErrorMessages: TagStore.errorMessage(),
      errorStatus: TagStore.getStatus()
    });

    if (TagStore.getNotify()) {
      this.createNotification(TagStore.getNotifyMsg());
      TagStore.setNotify();
    }

    if (this.state.errorStatus === true && (this.state.serverErrorMessages === 'fieldToFetch' || this.state.serverErrorMessages === 'sessionExpired')) {
      this.createNotification(this.state.serverErrorMessages);
      TagStore.setStatus();
      this.setState({errorStatus: TagStore.getStatus()});
      setTimeout(() => {
        // LoginStore.logout();
        // window.location.href = "/login";
      }, 2700);
    }
  }
}

export default StateTag;